import { MODAL_TYPES } from '@components/modals';
import { TREATMENT_PLAN_EDIT_DIALOG_DEFAULTS } from '@features/patient-context-bar/components/PatientTreatmentPlanEditModal.constants';

import type { ActionTargetMap } from './types';

export const defaultActionTargets: ActionTargetMap = {
  [MODAL_TYPES.TREATMENT_PLAN_EDIT]: {
    modalType: MODAL_TYPES.TREATMENT_PLAN_EDIT,
    defaultProps: TREATMENT_PLAN_EDIT_DIALOG_DEFAULTS,
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- payload values are untyped by design
    transformPayload: p => ({ patientId: p.patient_id }),
  },
  [MODAL_TYPES.NOTE_VIEWER]: {
    modalType: MODAL_TYPES.NOTE_VIEWER,
    defaultProps: {
      maxWidth: 'lg',
      fullScreenOnMobile: true,
      sx: {
        height: { xs: '100%', md: '80vh' },
        maxHeight: { xs: '100%', md: '80vh' },
      },
    },
    transformPayload: p => ({ noteId: p.note_id }),
  },
  [MODAL_TYPES.DOCUMENT_VIEWER]: {
    modalType: MODAL_TYPES.DOCUMENT_VIEWER,
    defaultProps: {
      maxWidth: 'lg',
      fullScreenOnMobile: true,
      sx: {
        height: { xs: '100%', md: '90vh' },
        maxHeight: { xs: '100%', md: '90vh' },
      },
    },
    transformPayload: p => ({ documentId: p.document_id }),
  },
};
